import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";

export default WidgetConfigurationCustomize;

interface WidgetConfigurationProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

function WidgetConfigurationCustomize(props: WidgetConfigurationProps) {
  const { open, onClose, children } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Customize Widget</DialogTitle>
      <DialogBody>{children}</DialogBody>
    </Dialog>
  );
}
